export enum LaunchDarklyFlagKeys {}

export enum DefaultVoyageType {
	OCEAN = 'OCEAN',
	RIVER = 'RIVER',
	OCEAN_RIVER = 'OCEAN,RIVER',
	NEITHER_OCEAN_OR_RIVER = '',
}

export interface LaunchDarklyFlags {
	datadogSessionReplaySampleRate: number;
	datadogRumSampleRate: number;
	enableAemUniversalNavigation: boolean;
	enableAffirm: boolean;
	enableBundledTaxesAndFees: boolean;
	enableCompareMedalliaSurvey: boolean;
	enableComparisonFeature: boolean;
	enableCruiseCardPriceSlide: boolean;
	enableCruiseDetailsPanelVariant: boolean;
	enableDateOption: boolean;
	enableDatadogRum: boolean;
	enableDefaultSortOption: string;
	enableEmailOnTargetedOffers: boolean;
	enableEventTrackng: boolean;
	enableFindACruiseWidget: boolean;
	enableGraphNlSearch: boolean;
	enableMedalliaEmbeddedSurvey: boolean;
	enableNaturalLanguageSearch: boolean;
	enableNaturalLanguageSearchVariations: string[];
	enablePercentageRolloutCampaign: {
		splitEx: string;
		toggles: LaunchDarklyFlags | null;
	};
	enablePricingPanelSailingHoverAnimation: boolean;
	enableQuickbookFunnel: boolean;
	enableRatingsAndReviews: {
		configuration: {
			notAllowedShips: string[];
		};
		enabled: boolean;
	};
	enableRecommendedSortOption: boolean;
	enableSendingLoyaltyidInCruiseSearchQuery: boolean;
	enableTargetedOffersFeature: boolean;
	enableUiRebranding: boolean;
	enableDefaultVoyageType: DefaultVoyageType;
	showAlertsOnHeader: boolean;
	showAllPortsFilter: boolean;
	showCruiseCardExpandedDetails: boolean;
	showCruiseCardViewItineraryCta: boolean;
	showDateRangeFilter: boolean;
	showDeparturePortsRegions: {
		code: string;
	}[];
	showFavoritesIconInTheItineraryTile: boolean;
	showFavoritesIconInThePricingPanel: boolean;
	showImagesInDestinationFilter: boolean;
	showImagesInShipsFilter: boolean;
	showInOrderThePillsOfTheFilters: string;
	showMarkerIoTab: boolean;
	showMyOffers: boolean;
	showPromotionBanner: boolean;
	showResetOnFilters: boolean;
	showRoomTypeFilter: boolean;
	showSearchBar: boolean;
	showSearchBarOnCustomFilters: {
		container: string;
		enabled: boolean;
	}[];
	showTargetedOffersPerksQualifiers: boolean;
	showUserFavoritesFeature: boolean;
	showUserWatchlistFeature: boolean;
	showWatchlistIconOnPricingPanel: boolean;
}

declare module 'launchdarkly-js-sdk-common' {
	export interface LDFlagSet extends LaunchDarklyFlags {}
}
